import { GIVEBACK2019_DESKTOP_BREAKPOINT } from '@/utils/browser';
import { easeOutQuad, font } from '@lemonade-hq/cdk';
import { lerp } from '@lemonade-hq/ts-helpers';
import styled from 'styled-components';

const Container = styled.div`
  @media (min-width: ${GIVEBACK2019_DESKTOP_BREAKPOINT}px) {
    ${font('alt', { fontSize: '6.2rem', lineHeight: 1.25, fontWeight: 'bold' })}
  }

  ${font('alt', { fontSize: '3rem', lineHeight: 1.25, fontWeight: 'bold' })}
`;

export default function RisingNumber({ fromValue, toValue, time }) {
  const value = Math.round(lerp(fromValue, toValue, easeOutQuad(time)));
  return <Container>{value.toLocaleString()}</Container>;
}
